module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3r1r2n-77b6ff8bf324e527ae5b0280265f7a74.svg";